import { defineMessages } from 'react-intl'

export default defineMessages({
  basicAssessment: {
    defaultMessage: 'Basisassessment',
  },
  protocol: {
    defaultMessage: 'Protokoll',
  },
  needs: {
    defaultMessage: 'Bedarfsassessment',
  },
  additionalInformation: {
    defaultMessage: 'Ergänzende Informationen',
  },
  overview: {
    defaultMessage: 'Bedarfsübersicht',
  },
  summary: {
    defaultMessage: 'Zusammenfassung + Abschluss',
  },
  notFound: {
    defaultMessage: 'Assessment nicht gefunden.',
  },
})
